module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-10.dec1cda2.png";